import React, { useEffect, useState } from 'react';
import { CompanyProvider } from './shared/context/CompanyContext';
import { AuthProvider, useAuth } from './shared/context/AuthContext';
import { ThemeProvider } from './shared/context/ThemeContext';
import { setPageTitle }  from './shared/context/CompanyContext';
import ThemeToggle       from './shared/components/ThemeToggle';
import LoginPage         from './shared/pages/LoginPage';
import TestPage          from './candidate/pages/TestPage';
import AdminPage         from './admin/AdminPage';
import ChangePasswordPage from './shared/pages/ChangePasswordPage';
import './index.css';

const ADMIN_ROLES = ['master_admin', 'admin', 'evaluator'];

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  return isMobile;
}

function MobileBlock() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      padding: '2rem', background: 'var(--bg)',
    }}>
      <div style={{fontSize: '4rem', marginBottom: '1.25rem'}}>🖥️</div>
      <h2 style={{fontSize:'1.35rem', fontWeight:700, color:'var(--text)', margin:'0 0 0.65rem'}}>
        Desktop Required
      </h2>
      <p style={{fontSize:'0.95rem', color:'var(--muted)', maxWidth:'320px', lineHeight:1.6, margin:0}}>
        The assessment must be taken on a <strong>laptop or desktop computer</strong>.
        Please switch to a larger screen to continue.
      </p>
      <div style={{
        marginTop:'2rem', padding:'0.85rem 1.1rem',
        background:'rgba(99,102,241,0.08)', border:'1px solid rgba(99,102,241,0.2)',
        borderRadius:'12px', fontSize:'0.82rem', color:'var(--muted)', maxWidth:'300px',
      }}>
        💡 Minimum screen width: <strong>768px</strong>
      </div>
    </div>
  );
}

function AppRoutes() {
  const { user, loading, mustChangePassword } = useAuth();
  const isMobile = useIsMobile();
  const isAdmin = user && ADMIN_ROLES.includes(user.role);

  useEffect(() => {
    if (loading) return;
    if (!user)                            setPageTitle('login');
    else if (mustChangePassword)          setPageTitle('changePassword');
    else if (ADMIN_ROLES.includes(user.role)) setPageTitle('admin');
    else                                  setPageTitle('test');
  }, [user, loading, mustChangePassword]);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: 'var(--bg)'
      }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!user) return <><ThemeToggle /><LoginPage /></>;

  if (isAdmin) {
    if (mustChangePassword) return <><ThemeToggle /><ChangePasswordPage /></>;
    return <AdminPage />;  // ThemeToggle is inside the admin header
  }

  // Candidates: block on mobile
  if (isMobile) return <MobileBlock />;

  return <><ThemeToggle /><TestPage /></>;
}

export default function App() {
  return (
    <CompanyProvider>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </CompanyProvider>
  );
}
